import React from "react";
import "./style.css";
import _, { includes } from "lodash";
import { Col, Row } from "reactstrap";

import { CPSiteTests, CPBatteryTests, CPSiteTestsExceptBattery, CPRelayTest, CPInsulationTest } from "./CombinedForms";

import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { ReportSectionSchema } from "./CP_CrossingReportSchema/ReportSectionSchema";
import { rowSection } from "./ReportSections/rowSection";
import { tableSection } from "./ReportSections/tableSection";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportFraConditionsMasterKey from "../../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";
import { SUPPORTED_CUSTOMERS, getCustomer } from "../../../MainPage/VersionInfo";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import { cnFraMasterKey } from "../../CN/cnFraMasterKeys";
import { batterySection } from "./ReportSections/batterySection";
import { relayReport } from "./ReportSections/relayReport";
import { insulationReport } from "./ReportSections/insulationReport";
import { genericTableSection } from "./ReportSections/genericTableSection";
import { getFieldsReportForm } from "../../sims/appFormReportsUtility";
import AssetAreaCondition from "../../PATH/AssetAreaConditionReport";

const genericCodes = [
  { key: "C", value: "Tests completed on all applicable components, no exceptions found, and condition left in compliance." },
  { key: "A", value: "Adjustments made (identified in associated comments), test completed, and condition left in compliance." },
  {
    key: "R",
    value: "Repairs and/or Replacements made (identified in associated comments), test completed, and condition left in compliance.",
  },
  { key: "G", value: "Governed by Special Instruction." },
  { key: "NT", value: "The equipment was not tested in this inspection." },
  { key: "NC", value: "Not Compliant." },
  { key: "N", value: "Test Not Applicable." },
];

const relayCodes = [
  { key: "C", value: "Test completed, condition left in compliance." },
  {
    key: "R",
    value: "Replacements made (identified in associated comments), test completed, and condition left in compliance.",
  },
  { key: "V", value: "Visual inspection completed, condition left in compliance." },
  { key: "NT", value: "The equipment was not tested in this inspection." },
  { key: "NC", value: "Not Compliant." },
  { key: "N", value: "No inspection required. The given relay does not require inspection at this time." },
];

const insulationCodes = [
  {
    key: "C",
    value: "Test completed, condition left in compliance. Indicates that all wires in trunking and cable measured 500K Ohms and above.",
  },
  {
    key: "A",
    value: "Annual test required; insulation resistance between 500K and 200K Ohms. Prompt action shall be taken to remedy condition.",
  },
  {
    key: "R",
    value: "Repairs and/or Replacements made (identifed in associated comments), test completed, and condition left in compliance.",
  },
  { key: "NT", value: "The equipment was not tested in this inspection." },
  { key: "NC", value: "Not Compliant" },
  { key: "N", value: "No inspection required. This is an annual re-inspection of a different conductor." },
];

function arrayMethod(testSched) {
  let data = [];
  let table = testSched && testSched.formData && testSched.formData.find((field) => field && field.type === "table");
  if (table && table.value) {
    data = getFieldsReportForm(table.value);
  }
  return data;
}

function sortArray(array, property) {
  if (array[0] && array[0][property]) {
    return array.slice().sort((a, b) => {
      let valueA = a[property] ? a[property].toLowerCase() : "N/A";
      let valueB = b[property] ? b[property].toLowerCase() : "N/A";

      if (valueA < valueB) {
        return -1;
      }
      if (valueA > valueB) {
        return 1;
      }
      return 0;
    });
  } else {
    return array;
  }
}

export function showEmptyColumn() {
  return <Col md={12}>{<div className="comments-text info-section"> </div>}</Col>;
}

const sectionHeader = (props, type, showStandby) => {
  const style = {
    relay: {
      code: relayCodes,
      title: "Inspection Report - Relay Tests and Inspections",
    },
    insulation: {
      code: insulationCodes,
      title: "Inspection Report - Insulation Tests and Inspections",
    },
    generic: {
      code: genericCodes,
      title: "Test & Inspection Report",
    },
  };

  return (
    <React.Fragment>
      <Row>
        <Col md={4}>{<ReportTitleSection {...props} fontSizeOverride={"30px"} />}</Col>
        <Col md={8}>
          <h1 style={{ fontWeight: "900", marginTop: "15px" }}>{style[type].title}</h1>
        </Col>
      </Row>
      {showEmptyColumn()}
      <ReportFraInfoSectionContainer {...props} />
      {showEmptyColumn()}
      <ReportFraConditionsMasterKey masterKey={getCustomer() === SUPPORTED_CUSTOMERS ? cnFraMasterKey : style[type].code} />
      {showEmptyColumn()}

      <div className="info-note">
        {type === "generic" && showStandby ? (
          <strong>
            NOTE: For Stand By Power (FRA 234.251), an indication of "C" denotes that all battery buses, as listed under Grounds (FRA
            234.249), were tested. If any battery bus fails the Stand By Power test, that bus will be named in the notes associated with the
            Stand By Power test.
          </strong>
        ) : (
          <p> </p>
        )}
      </div>
    </React.Fragment>
  );
};

const isStandByTable = (tests) => {
  let show = false;
  tests &&
    tests.length > 0 &&
    tests.map((testForm, _i) => {
      if (testForm.testCode === "FRA234_251" || testForm.testCode === "CP_Monthly_FRA234_251") {
        let data = arrayMethod(testForm);
        if (data.length == 0) {
          show = true;
        }
      }
    });

  return show;
};

const ReportView = (props) => {
  let { data } = props;
  const reportTypes = {
    tableSection: (data) => tableSection(data),
    batteryReport: (data) => batterySection(data, props.selectedAsset),
    relayType: (data) => relayReport(data),
    insulationType: (data) => insulationReport(data),
    generic: (data) => rowSection(data),
    genericTableSection: (data) => genericTableSection(data),
  };

  const headerStyle = {
    relay: "mainContent table-report RelayTestInspectionCP last-page-break-print",
    insulation: "mainContent table-report InsulationTestInspectionCP last-page-break-print",
    generic: "mainContent table-report CrossingTestsInspectionsCP last-page-break-print",
  };

  const decodedData = Array.isArray(data.decodedData) ? data.decodedData : [];

  let showStandby = isStandByTable(decodedData);

  const nonGenericCodesList = [...CPBatteryTests.map((cp) => cp.code)];

  const genericCodesList = [...CPSiteTestsExceptBattery.map((cp) => cp.code)];

  const relayCodesList = [...CPRelayTest.map((cp) => cp.code)];

  const insulationCodesList = [...CPInsulationTest.map((cp) => cp.code)];

  const isGenericReport = decodedData.find((t) => nonGenericCodesList.includes(t.testCode)) ? false : true;

  let reportDataType = decodedData.find((t) => genericCodesList.includes(t.testCode))
    ? "generic"
    : decodedData.find((t) => relayCodesList.includes(t.testCode))
    ? "relay"
    : "insulation";
  const assetAreaConditionData = decodedData.filter((t) => t.testCode === "PATH_AssetAreaCondition");
  let showReport = assetAreaConditionData.length !== decodedData.length;
  let ReportSchema = ReportSectionSchema.map((Section) => {
    let getSectionTests = decodedData.filter((t) => Section.tests.includes(t.testCode));
    getSectionTests = sortArray(getSectionTests, "title");
    let type = Section.type ? Section.type : "generic";

    return getSectionTests.length !== 0 ? (
      <React.Fragment>
        <Col md={12}>
          <Row>
            {reportTypes[type](getSectionTests)}
            {showEmptyColumn()}
          </Row>
        </Col>
      </React.Fragment>
    ) : null;
  });

  return (
    showReport && (
      <React.Fragment>
        <div className={headerStyle[reportDataType]} style={{ minHeight: "800px" }}>
          {isGenericReport && sectionHeader(props, reportDataType, showStandby)}
          {assetAreaConditionData.length > 0 && (
            <Col md={12}>
              <AssetAreaCondition data={assetAreaConditionData} />
            </Col>
          )}
          {ReportSchema}
        </div>
      </React.Fragment>
    )
  );
};

export default function CPCrossingReport(props) {
  let { reportData } = props;
  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let noConditionGroupReport = ReportGroupingUtils.groupReportsOnly(reportData);

  //other report
  let newreportData = ReportGroupingUtils.filterReportsByTestCodesAndUpdateDuplicateTestCodes(reportsByDateAndUser, [
    ...CPSiteTestsExceptBattery.map((cp) => cp.code),
    "PATH_AssetAreaCondition",
  ]);

  let genericDecodedData = ReportGroupingUtils.decodeTestsInReportGroups(
    newreportData,
    CPSiteTestsExceptBattery.map((cp) => cp.code),
  );

  //relayReport
  let relayReportData = ReportGroupingUtils.filterReportsByTestCodes(reportsByDateAndUser, [...CPRelayTest.map((cp) => cp.code)]);

  let relayDecodedData = ReportGroupingUtils.decodeTestsInReportGroups(
    relayReportData,
    CPRelayTest.map((cp) => cp.code),
  );

  //insulationReport
  let insulationReportData = ReportGroupingUtils.filterReportsByTestCodes(reportsByDateAndUser, [...CPInsulationTest.map((cp) => cp.code)]);

  let insulationDecodedData = ReportGroupingUtils.decodeTestsInReportGroups(
    insulationReportData,
    CPInsulationTest.map((cp) => cp.code),
  );

  //batteryReport

  let batteryReportData = ReportGroupingUtils.filterReportsByTestCodes(
    noConditionGroupReport,
    CPBatteryTests.map((cp) => cp.code),
  );

  let batteryDecodedData = ReportGroupingUtils.decodeTestsInReportGroups(
    batteryReportData,
    CPBatteryTests.map((cp) => cp.code),
  );

  let decodedData = [].concat(genericDecodedData, insulationDecodedData, relayDecodedData, batteryDecodedData);

  //removing empty data
  decodedData = decodedData.filter((data) => data.reports.length > 0);
  return decodedData.map((report, i) => <ReportView key={i} {...props} data={report} />);
}



// WEBPACK FOOTER //
// ./src/components/Reports/CP/NewCrossingReport/CP_CrossingReport.jsx